import React, { useState } from 'react';
import LucideIcon from 'src/componentes/lucide-icon';
import Badge from 'src/componentes/Badge';
import Pager from 'src/componentes/pagination';
import history from 'src/history';
import qs from 'query-string';
import './ValidacaoRestricaoLista.css';

const TAMANHO_PAGINA = 20;

function obterItens(restricao) {
  if (restricao?.itens?.length) {
    return restricao.itens;
  }

  return (restricao?.itensDescricao || []).map((descricao) => ({
    descricao,
  }));
}

function obterDescricao(item) {
  return typeof item === 'string' ? item : item?.descricao || '';
}

function abrirEmNovaAba(url, item) {
  if (!url || !item?.id) return;

  const [pathname, query] = url.split('?');
  const params = qs.parse(query || '');
  params.id = item.id;

  window.open(
    history.createHref({
      pathname,
      search: `?${qs.stringify(params)}`,
    }),
    '_blank',
    'noopener,noreferrer'
  );
}

function renderItem(item, chave) {
  const descricao = obterDescricao(item);
  const podeRedirecionar = !!(item?.url && item?.id);

  return (
    <li key={chave} className="validacao-restricao-lista__item">
      {podeRedirecionar ? (
        <>
          <LucideIcon
            icon="Link2"
            size={14}
            className="validacao-restricao-lista__icone"
          />
          <button
            type="button"
            className="validacao-restricao-lista__link text-truncate"
            title={descricao}
            onClick={() => abrirEmNovaAba(item.url, item)}
          >
            {descricao}
          </button>
        </>
      ) : (
        <span
          className="validacao-restricao-lista__texto text-truncate"
          title={descricao}
        >
          {descricao}
        </span>
      )}
    </li>
  );
}

export default function ValidacaoRestricaoLista({
  restricoes = [],
  instrucao,
  paginar = false,
}) {
  const [paginas, setPaginas] = useState({});

  if (!restricoes?.length) {
    return null;
  }

  const aoMudarPagina = (indice, pagina) => {
    setPaginas((anterior) => ({ ...anterior, [indice]: pagina }));
  };

  return (
    <div className="validacao-restricao-lista">
      {instrucao && (
        <div className="validacao-restricao-lista__cabecalho-fixo">
          <p className="validacao-restricao-lista__instrucao">{instrucao}</p>
          <div className="validacao-restricao-lista__divisor" />
        </div>
      )}

      <div className="validacao-restricao-lista__conteudo">
        {restricoes.map((restricao, indice) => {
          const itens = obterItens(restricao);
          // A confirmação de exclusão é a única sem vínculos, se tiver vínculos exibe cabeçalho com contador.
          const possuiVinculos = !!restricao.itens?.length;
          const ehConfirmacao = !!restricao.podeExcluir && !possuiVinculos;
          const devePaginar = paginar && itens.length > TAMANHO_PAGINA;
          const totalPaginas = Math.ceil(itens.length / TAMANHO_PAGINA);
          const paginaAtual = paginas[indice] || 1;
          const itensExibidos = devePaginar
            ? itens.slice(
                (paginaAtual - 1) * TAMANHO_PAGINA,
                paginaAtual * TAMANHO_PAGINA
              )
            : itens;

          return (
            <section
              key={`${restricao.restricaoDescricao}-${indice}`}
              className="validacao-restricao-lista__secao"
            >
              {ehConfirmacao ? (
                restricao.restricaoDescricao && (
                  <p className="validacao-restricao-lista__confirmacao">
                    {restricao.restricaoDescricao}
                  </p>
                )
              ) : (
                <div className="validacao-restricao-lista__cabecalho">
                  <h6
                    className="validacao-restricao-lista__titulo text-truncate"
                    title={restricao.restricaoDescricao}
                  >
                    {restricao.restricaoDescricao}
                  </h6>
                  <Badge
                    color="light"
                    className="validacao-restricao-lista__contador"
                  >
                    {itens.length}
                  </Badge>
                </div>
              )}

              <ul className="validacao-restricao-lista__itens">
                {itensExibidos.map((item, indiceItem) =>
                  renderItem(
                    item,
                    `${indice}-${indiceItem}-${item?.id || obterDescricao(item)}`
                  )
                )}
              </ul>

              {!ehConfirmacao && devePaginar && (
                <div className="validacao-restricao-lista__paginacao">
                  <Pager
                    activePage={paginaAtual}
                    totalPages={totalPaginas}
                    pageChanged={(pagina) => aoMudarPagina(indice, pagina)}
                  />
                </div>
              )}
            </section>
          );
        })}
      </div>
    </div>
  );
}
